export const COOKIE_NAME = 'OptOutOnRequest';

export const STRICTLY_NECESSARY = 'C0001';
export const PERFORMANCE = 'C0002';
export const FUNCTIONALITY = 'C0003';
export const TARGETING = 'C0004';
export const SOCIAL_MEDIA = 'C0005';

export const OPT_IN = '1';
export const OPT_OUT = '0';

export const cookies = [
  {
    label: 'Strictly Necessary Cookies',
    value: STRICTLY_NECESSARY,
    description: 'These cookies are essential for the website to function properly.',
  },
  {
    label: 'Performance Cookies',
    value: PERFORMANCE,
    description: 'These cookies help us understand how visitors interact with our website.',
  },
  {
    label: 'Functionality Cookies',
    value: FUNCTIONALITY,
    description: 'These cookies enable enhanced functionality and personalization.',
  },
  {
    label: 'Targeting Cookies',
    value: TARGETING,
    description: 'These cookies are used to deliver relevant advertisements.',
  },
  {
    label: 'Social Media Cookies',
    value: SOCIAL_MEDIA,
    description: 'These cookies enable social media features.',
  },
];

export const initialCookieValues = cookies.reduce((acc, cookie) => {
  // strick should always be true
  if (cookie.value === 'C0001') {
    acc[cookie.value] = true;
    return acc;
  }

  acc[cookie.value] = false;
  return acc;
}, {});

export function isStrictlyNecessary(cookieValue) {
  return cookieValue === STRICTLY_NECESSARY;
}

export function getConsentCookie() {
  return document.cookie.split('; ').find(row => row.startsWith(`${COOKIE_NAME}=`));
}

export function clearConsentCookie() {
  document.cookie = `${COOKIE_NAME}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}

/**
 * Mirrors OneTrust consent values
 * @see https://developer.onetrust.com/onetrust/docs/when-consent-changes-new#querying-consent-status-for-a-category
 *
 * - 0 = opt out / no consent given
 * - 1 = opt in / consent given
 */
export function modifyConsentCookie(cookieConsent) {
  const cookieValue = Object.entries(cookieConsent)
    .map(([key, val]) => {
      // cannot opt out of strickly necessary cookies
      if (isStrictlyNecessary(key)) {
        return `${key}%3A${OPT_IN}`;
      }

      return `${key}%3A${val ? OPT_IN : OPT_OUT}`;
    })
    .join('%2C');

  document.cookie = `${COOKIE_NAME}=groups=${cookieValue}; path=/; expires=${new Date(
    Date.now() + 7 * 24 * 60 * 60 * 1000
  ).toUTCString()}`;
}
